import React from 'react';
import { Checkbox } from 'components/ui/checkbox';
import { Input } from 'components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/ui/select';
import { IFilterConfig, IFilterConfigNumber } from './types';

interface IProps {
  item: IFilterConfig;
  setSelected: (arg1: string, arg2: boolean) => void;
  setValue: (arg1: string, arg2: number, arg3: string) => void;
}

const NumberFilter = ({ item, setSelected, setValue }: IProps): JSX.Element => {
  const { selected, key, label, data } = item;
  const { values } = data as IFilterConfigNumber;
  const condition = values[0];
  const firstNumber = values[1];
  const secondNumber = values[2];
  return (
    <>
      <div className="flex items-center gap-2 px-2 py-1">
        <Checkbox
          id={label}
          data-testid="number-checkbox"
          data-cy="amountFilters"
          checked={selected}
          onCheckedChange={(checked) => setSelected(key, checked === true)}
        />
        <label htmlFor={label} className="body-subtext-regular">
          {label}
        </label>
      </div>

      {selected && (
        <div className="flex flex-col gap-2 px-2 pb-2">
          <Select
            value={condition || 'equal'}
            onValueChange={(value) => {
              setValue(key, 0, value);
              if (value !== 'between') {
                setValue(key, 2, '');
              }
            }}
          >
            <SelectTrigger data-testid="condition-select" className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="equal" data-testid="equal">
                equal
              </SelectItem>
              <SelectItem value="between" data-testid="between">
                between
              </SelectItem>
              <SelectItem value="greater than" data-testid="greater-than">
                greater than
              </SelectItem>
              <SelectItem value="less than" data-testid="less-than">
                less than
              </SelectItem>
            </SelectContent>
          </Select>

          <div className="flex items-center gap-2">
            <Input
              data-testid="first"
              placeholder="0"
              type="number"
              defaultValue={firstNumber}
              onChange={(e) => {
                setValue(key, 0, values[0]);
                setValue(key, 1, e.target.value);
              }}
            />
            {condition === 'between' && (
              <>
                <span className="text-gray-blue-50">–</span>
                <Input
                  data-testid="second"
                  placeholder="0"
                  type="number"
                  defaultValue={secondNumber}
                  onChange={(e) => {
                    setValue(key, 0, values[0]);
                    setValue(key, 2, e.target.value);
                  }}
                />
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default NumberFilter;
